/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import moment from 'moment';
import * as momentTz from 'moment-timezone';


// project imports
import Datatable from 'shared/datatable';
import { locationlist, messagelistbyitem } from 'shared/settings/apiconfig';
import { Link } from 'react-router-dom';

// style imports
import './MessageList.scss';
import axios from 'axios';
import { getSellerHeaders, getSellerUrl } from 'shared/http';
import { ArrayValueReorder } from 'shared/modifiers';
import { Button, Col, Form, Row } from 'react-bootstrap';


/**
 * this page is used to list messages
 * 
 * @param props
 * 
 * @returns html code to render the message list
 * 
**/

export class MessageList extends Component {

    config;

    constructor(props) {
        super(props);

        this.dataTable = createRef();

        /* initial search state */
        this.initialSearchState = {
            locationid: { field: 'locationid', value: '', op: '=', join: 'AND' },
        }

        this.state = {
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            locations: [],
            isdisabled: false,
            locationlength: 0,
            pageLoading: true,
            tableData: [],
        };

        this.config = {
            url: messagelistbyitem,
            params: {},
            columns: [
                { name: 'Item Title', property: 'itemtitle', sort: true, width: '220px', columnType: 'custom', customColumn: this.customCell('itemtitle') },
                { name: 'Sale Title', property: 'saletitle', sort: true, width: '220px', columnType: 'custom', customColumn: this.customCell('saletitle') },
                { name: 'Messages', property: 'messagecount', sort: true, width: '105px', columnType: 'custom', customColumn: this.customCount, needState: true },
                { name: 'Date', property: 'createddate', sort: true, width: '150px', columnType: 'custom', sortType: 'date', customColumn: this.customDate }
            ],
            sort: [{ field: 'createddate', direction: 'desc'  }],
            pagination: true,
            field: ['itemid', 'itemtitle', 'saletitle', 'createddate', 'messagecount', 'locationid']
        };
    }

    componentDidMount() {
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    customCell = (property) => {
        return (row) => (row['messagecount'] ? <b>{row[property]}</b> : <span>{row[property]}</span>);
    };

    customDate = (value) => {
        if (value['createddate']) {
            return `${moment.utc(value['createddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    customCount = (row, state) => {
        let data = {}
        data['datatable'] = this.state.tableData.stateData;

        return (
            <Link to={{ pathname: `/messages/reply/${row['itemid']}`, state: data }} >
                <div className="d-flex flex-row justify-content-center align-items-center border bg-white clickable"
                    style={{ borderRadius: "50%", height: "30px", width: "30px" }}
                    onClick={() => this.routeToReply(row['itemid'], state)}>
                    {
                        row['messagecount'] ?
                            <b style={{ marginTop: "1px" }}>{row['messagecount']}</b> :
                            <span style={{ marginTop: "1px" }}>0</span>
                    }
                </div>
            </Link>
        );
    };

    routeToReply = (itemId, state) => {
        let data = {}
        data['datatable'] = this.state.tableData.stateData;
        this.props.history.push({ pathname: `/messages/reply/${itemId}`, state: data });
    };


    getLocationStateData = () => {
        const locationState = this.props?.location?.state;
        const locationSearch = locationState?.datatable?.search;
        if (!(locationSearch && !locationState?.prevPath)) {
            return;
        }
        const updatedState = {};
        updatedState['search'] = locationSearch?.length > 0 ? [...locationSearch].reduce(
            (acc, element) => {
                const elementDestruct = { ...element };
                acc[elementDestruct['field']] = elementDestruct;
                return acc;
            }, { ...this.initialSearchState }) :
            {
                locationid: {
                    ...this.initialSearchState.locationid,
                    value: 0
                }
            };
        updatedState['issearch'] = Boolean(updatedState['search']?.length);
        updatedState['searchData'] = true;
        this.setState({
            isdisabled: true,
        })
        return updatedState;
    }

    /* Get Location list */
    getLocationList = async () => {
        await axios.all([
            await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
            .then(response => {
                this.locations = response[0].data.data;
                const locationState = this.getLocationStateData();
                if (this.locations.length === 1) {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        isdisabled: true,
                        search: {
                            ...this.state.search,
                            locationid: {
                                ...this.state.search.locationid,
                                value: this.locations[0].id
                            },
                        },
                        pageLoading: false,
                        ...locationState
                    }, () => {
                        if (!locationState) {
                            this.enableSearch();
                        }
                    });
                }
                else {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        pageLoading: false,
                        ...locationState
                    });
                }
            })
            .catch(error => {
                this.setState({
                    pageLoading: false
                });
            });

    }
    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        this.setState({
            ...this.state,
            issearch: true,
            isdisabled: true,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: Number(eventValue)
                }
            },
            searchData: false
        }, () => {
            if (event.target.value === '')
                this.resetState();
        });
    }

    /* called when clear in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            isdisabled: false
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* called when search button clicked */
    enableSearch = () => {
        var search = {
            locationid: { ...this.state.search.locationid },
        }
        this.setState({
            search: search,
            searchData: true
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    render() {

        return (
            <div className={`${this.state.pageLoading ? 'h-100' : ''} overflow-auto`}>
                {
                    this.state.pageLoading ? <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div> :
                        <div>
                            <div className="sale-search" style={{backgroundColor: '#BBC7D6'}}>
                                <div className="sales-list-search">
                                    <Form className="sales-list-font">
                                        <div className="sales-search-container">
                                            <Row md={5}>
                                                <Col>
                                                    <label>Location *</label>
                                                    <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onChange={(event) => this.searchInputChange(event)}>
                                                        <option value="" disabled>Please select location</option>
                                                        <option value={0}>All</option>
                                                        {this.state.locations.map((loc, index) =>
                                                            <option key={index} value={loc.id}>{loc.title}</option>
                                                        )}
                                                    </Form.Control>
                                                </Col>
                                                <Col>
                                                    <div className="mt-3">
                                                        <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                                        <Button variant="seller-search" disabled={!this.state.isdisabled} onClick={() => this.enableSearch()}>Search</Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                            <div className="message-list">
                                <Datatable {...this.props} config={this.config} search={this.state.searchData ? { search: this.state.search.locationid.value === 0 ? {} : { ...this.state.search }, searchData: this.state.searchData } : null} ref={this.dataTable}
                                    onDataUpdate={this.updateTableData} />
                            </div>
                        </div>
                }
            </div>
        );
    }
}